import React, { useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import CustomFilterOptions from "./CustomFilter";
import Popover from "../Popover/Popover";
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);

const LineChart = (props) => {
  const [channelPopover, setChannelPopover] = useState(false);
  const options = {
    responsive: true,
    layout: {
      padding: 20,
    },
    scales: {
      y: {
        ticks: {
          callback: function (value, index, ticks) {
            return value;
          },
        },
        title: {
          display: true,
          text: props.yTitle ? props.yTitle : "Applicant",
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
  };
  const labels = props?.labels;
  const data = {
    labels,
    datasets: props?.datasets,
  };

  const renderLable = () => {
    return props?.datasets.map((labelData) => (
      <>
        <span
          className="color"
          style={{
            backgroundColor: labelData.backgroundColor,
            borderColor: labelData.borderColor,
          }}
        ></span>
        <span
        style={{
          color:labelData.borderColor
        }}
         className="title">{labelData.label}</span>
      </>
    ));
  };

  if (props?.datasets && props?.datasets.length > 0) {
    return (
      <>
        <div className="chart-title-container">
          <strong>{props?.title}</strong>
          <div className="chart-btn-group">
            <button
              className={`btn btn-outline chart-custom-button ${
                props.selectedChartFilter === "3M" ? "chart-fill-btn" : ""
              }`}
              onClick={() => props.renderChartData("3M", 3)}
            >
              3M
            </button>
            <button
              className={`btn btn-outline chart-custom-button ${
                props.selectedChartFilter === "6M" ? "chart-fill-btn" : ""
              }`}
              onClick={() => props.renderChartData("6M", 6)}
            >
              6M
            </button>
            <button
              className={`btn btn-outline chart-custom-button ${
                props.selectedChartFilter === "1Y" ? "chart-fill-btn" : ""
              }`}
              onClick={() => props.renderChartData("1Y", 12)}
            >
              1Y
            </button>
            <button
              className={`btn btn-outline chart-custom-button ${
                props.selectedChartFilter === "custom" ? "chart-fill-btn" : ""
              }`}
              id="customeFilter"
            >
              Custom
            </button>
          </div>

          <Popover
            popoverOpen={channelPopover}
            target="customeFilter"
            handleToggle={() => {
              setChannelPopover(!channelPopover);
            }}
            title={""}
            pbody={
              <CustomFilterOptions
                type="dashboard"
                handleCustomFilterOption={props.handleCustomFilterOption}
                setChannelPopover={setChannelPopover}
                selectedChartFilter={props.selectedChartFilter}
                customFilter={props?.customFilter}
              />
            }
            classname="report-popover"
            placement="bottom-end"
          />
        </div>
        <div className="legend-group">{renderLable()}</div>
        <Line options={options} data={data} />
      </>
    );
  }
};

export default LineChart;
